module.exports = __webpack_public_path__ + "img/check-search.0a896472.svg";